<template>
  <div>
    <v-list-item
      active-class="menu--active"
      v-for="link in links"
      :key="link.name"
      v-ripple
      @click="$vuetify.goTo(link.destination, {duration: 600, offset: 0, easing: 'easeInOutCubic'}), $store.state.drawer = !$store.state.drawer, logo = 'she_face'"
    >            
      <v-list-item-title class="menu--item text-xs-left centerMe" v-text="link.name"></v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          name: 'Up Top',
          destination: '#global-economy'
        },
        {
          name: 'She NFTs',
          destination: '#nft'
        },
        {
          name: 'The Gist',
          destination: '#woman-to-woman'
        },
        {
          name: 'Our Tech',
          destination: '#connect'
        },
        {
          name: 'She Token',
          destination: '#tech'
        },
        {
          name: 'The Team',
          destination: '#team-sec'
        },
        {
          name: 'Join Us',
          destination: '#join'
        }
      ]
    }
  }
}
</script>

<style>
.centerMe {
    max-width: 160px;
    margin: 0 auto;
}
</style>
